import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ACHierarchy(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.85 14C19.1846 14.0001 20.267 15.0824 20.267 16.417V18.083C20.267 19.4176 19.1846 20.4999 17.85 20.5H13.684C12.3493 20.5 11.267 19.4177 11.267 18.083V16.417C11.267 15.0823 12.3493 14 13.684 14H17.85ZM13.684 15.5C13.1777 15.5 12.767 15.9107 12.767 16.417V18.083C12.767 18.5893 13.1777 19 13.684 19H17.85C18.3562 18.9999 18.767 18.5892 18.767 18.083V16.417C18.767 15.9108 18.3562 15.5001 17.85 15.5H13.684Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M5.35002 4C5.76423 4 6.10002 4.33579 6.10002 4.75V7.33398H9.51701L9.59319 7.33789C9.97143 7.37624 10.267 7.69562 10.267 8.08398C10.2667 8.4721 9.97127 8.79179 9.59319 8.83008L9.51701 8.83398H6.10002V15.583L6.1049 15.6768C6.15172 16.1391 6.5423 16.5 7.01701 16.5H9.51701L9.59319 16.5039C9.97146 16.5422 10.267 16.8616 10.267 17.25C10.267 17.6384 9.97146 17.9578 9.59319 17.9961L9.51701 18H7.01701C5.76563 18 4.73633 17.0489 4.61272 15.8301L4.60002 15.583V4.75C4.60002 4.33579 4.93581 4 5.35002 4Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.85 4.83301C19.1845 4.83314 20.2668 5.91553 20.267 7.25V8.91602C20.267 10.2506 19.1846 11.3329 17.85 11.333H13.684C12.3493 11.333 11.267 10.2507 11.267 8.91602V7.25C11.2672 5.91545 12.3494 4.83301 13.684 4.83301H17.85ZM13.684 6.33301C13.1778 6.33301 12.7672 6.74388 12.767 7.25V8.91602C12.767 9.42228 13.1777 9.83301 13.684 9.83301H17.85C18.3562 9.83288 18.767 9.4222 18.767 8.91602V7.25C18.7668 6.74396 18.3561 6.33314 17.85 6.33301H13.684Z"
        fill="currentColor"
      />
    </svg>
  );
};
